import { render } from "./CreateLiquidation2.vue?vue&type=template&id=85860a82"
import script from "./CreateLiquidation2.vue?vue&type=script&lang=js"
export * from "./CreateLiquidation2.vue?vue&type=script&lang=js"

import "./CreateLiquidation2.vue?vue&type=style&index=0&id=85860a82&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__